<template>
	<div class="saved-payments">
		<div class="saved-payments__wrapper">
			<label
				class="saved-payments__item"
				v-for="payment in payments"
				:key="payment.token"
				:class="{
					'saved-payments__item--active': value == payment.token,
					'saved-payments__item--disabled': payment.disabled,
					'saved-payments__item--readonly': readonly,
					'saved-payments__item--error': error,
				}"
			>
				<input
					type="radio"
					class="saved-payments__item-radio"
					name="saved-payments"
					:value="payment.token"
					:checked="value == payment.token"
					:disabled="payment.disabled || (readonly && value != payment.token)"
					@change="onInput"
				/>
				<span
					class="saved-payments__item-title"
					v-html="payment.paymentMethodTitle"
				/>
				<div class="saved-payments__item-content">
					<img
						v-if="payment.image"
						class="saved-payments__item-image"
						:src="payment.image"
					/>
					<span
						class="saved-payments__item-name"
						v-html="payment.name"
					/>
					<span class="saved-payments__item-checkbox"/>
				</div>
				<Button
					@click.prevent="onDelete(payment)"
					type="button"
					level="tertiary"
					:text="'löschen'"
					arrow
				/>
			</label>
		</div>
		<span
			class="form-input__hint | form-input-hint"
			v-if="hint"
			v-html="hint"
		/>
		<span
			class="form-input__error | form-input-error"
			v-if="error && errorMessage"
			v-html="errorMessage"
		/>
		<span
			class="form-input__success | form-input-success"
			v-if="successMessage"
			v-html="successMessage"
		/>
	</div>
</template>

<script>
import Button from '@/components/Button'

export default {
	components: {
		Button,
	},
	props: {
		payments: Array,
		value: String,
		readonly: Boolean,
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	methods: {
		onDelete(payment) {
			this.$emit('delete', payment);
		},
		onInput(e) {
			if (e.target.checked) {
				this.$emit('input', e.target.value);
			}
		},
	}
}
</script>

<style>

</style>
